import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage.js';
import { studentSelectAvatar, studentUpdateMissionById } from '../../services/pstudentMissions.service.js';
import { publicFetchMissionById } from '../../services/pmissions.service.js';
import MDEditor from '@uiw/react-md-editor';
import LogoNoText from '../../svg/LogoNoText.js';
import PreviousSvg from '../../svg/student/Previous.js';
import NextSvg from '../../svg/student/Next.js';
import ReloadSvg from '../../svg/student/Reload.js';
import Instructions from '../primary_student/Instructions.js';
import Timer from '../primary_student/components/Timer.js'
import PopupWindow from '../primary_admin/components/TextPopupWindow.js';
import DropDownMenu from '../components/DropDownMenu.js'
import AvatarSelect from '../../svg/pstudent/AvatarSelect.js'
import AvatarNextButton from '../../svg/pstudent/AvatarNextButton.js';
import AvatarTeacher from '../../svg/pstudent/AvatarTeacherNext.js';
import ResultStudentReport from './ResultsStudentReports.js';

function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setdata] = useState(null)
    const [mission, setmission] = useState(null)
    const [isLoading, setisLoading] = useState(false)
    const isMobile = window.innerWidth <= 1024
    const isSuperSmall = window.innerWidth <= 600
    const scrollRef = React.useRef(null);


    const fetchMission = async () => {
        let result = await publicFetchMissionById(  id );
        if (result.result) {
            setmission(result.result || null)
        } else {
            alert('Fetch data error')
        }
    }



    const handleStartMission = async () => {
        setisLoading(true)
        setisDoingMission(true)
        setisLoading(false)
    }

    const refresh = async () => {
        if (isLoading) return
        setisLoading(true)
        // await fetchData()
        await fetchMission()
        // await fetchSchoolMission()
        setisLoading(false)
    }

    useEffect(() => {
        refresh()
    }, [id])

    const [hasConsented, sethasConsented] = useState(null);
    const handleConsent = (boo) => async () => {
        setisLoading(true);
        sethasConsented(boo);
        //to do update consent later
        setisLoading(false)
    }



    const [isDoingMission, setisDoingMission] = useState(false);
    const [isCompleted,setisCompleted]=useState(false);
    const [remainingTime, setremainingTime] = useState(0);
    const [startTime, setstartTime] = useState(null);
    useEffect(() => {
        let timeInterval = null
        if (!isDoingMission) { return }
        if (!startTime) { return }
        if (!mission?.time) { return }
        timeInterval = setInterval(() => {
            let second = (new Date(startTime).getTime() + mission.time * 60 * 1000 - Date.now()) / 1000
            setremainingTime(second <= 0 ? 0 : second)
        }
            , 1000)
        return () => { clearInterval(timeInterval) }
    }, [mission, isDoingMission,startTime])


    const autoSubmit = async () => {
        // setisLoading(true)
        // let result = await studentFinishMission(props.token.token, mission._id, mission.questions, progress)
        // if (result.result) {
        //     await fetchMission()
        // } else {
        //     console.log(JSON.stringify(result?.message))
        // }
        setisCompleted(true)
        // setisLoading(false)
    }
    useEffect(() => {
        if (mission?.status === '進行中') {
            if (new Date(startTime).getTime() + mission.time * 60 * 1000 - Date.now() <= 0) {
                alert('時間到');
                autoSubmit();
            }
        }
    }, [mission, remainingTime,startTime])

    const getRemainingTimeString = () => {
        if ((!remainingTime) || remainingTime <= 0) return '00:00'
        let time = remainingTime
        let hours = Math.floor(time / 3600);
        let minutes = Math.floor((time - (hours * 3600)) / 60);
        let seconds = Math.floor(time - (hours * 3600) - (minutes * 60));
        //return `${hours < 10 ? `0` : ''}${hours}:${minutes < 10 ? `0` : ''}${minutes}:${seconds < 10 ? `0` : ''}${seconds}`
        return `${minutes < 10 ? `0` : ''}${minutes}:${seconds < 10 ? `0` : ''}${seconds}`
    }
    const [questionIndex, setquestionIndex] = useState(0);
    const selectQuestion = (item, index) => () => {
        //do nothing
        return
        if (index <= progress)
            setquestionIndex(index)
    }
    const progress = mission?.progress || 0

    const handleStart = async () => {
        setisLoading(true)
        setstartTime(new Date())
        setisLoading(false)
    }

    const [tabIndex, settabIndex] = useState(0);


    const saveAndGoToQuestion = async (question_Index) => {
        setisLoading(true)
        let pages = mission?.pages

        setquestionIndex(question_Index)
        
        // let result = await studentUpdateMissionById(props.token?.token, mission._id, {
        //     questions: mission?.questions,
        //     progress,
        //     pages,
        // })
        // if (result.result) {
        //     await fetchMission()
        //     setquestionIndex(question_Index)
        // } else {
        //     alert(JSON.stringify(result?.message))
        // }
        setisLoading(false)
    }

    const handleNextQuestion = async () => {
        if (['選擇題', '選擇題 + 短句作答題', '選擇網頁'].includes(mission?.questions?.[questionIndex].type)) {
            if (mission?.questions?.[questionIndex].options?.filter(option => option.isSelected).length === 0) {
                alert('請選擇答案')
                return
            }
        }
        if (['短句作答題', '選擇題 + 短句作答題'].includes(mission?.questions?.[questionIndex].type)) {
            if (!mission?.questions?.[questionIndex].answer) {
                alert('請回答問題')
                return
            }
            if ((!mission?.questions?.[questionIndex].answer2) && mission?.questions?.[questionIndex].hasTwoAnswers) {
                alert('請填寫第二個答案')
                return
            }
        }
        if (['表格問題'].includes(mission?.questions?.[questionIndex].type)) {
            if (mission?.questions?.[questionIndex].multipleChoiceType !== '多項選擇題') {
                if (mission?.questions?.[questionIndex]?.table?.filter(row => ((!row.answer1) && (!row.answer2))).length > 0) {
                    alert('請選擇答案')
                    return
                }
            }
        }
        if (questionIndex === mission?.questions?.length - 1) {
            setshowReadySubmitPopup(true)
            return
        }


        setisLoading(true)
        let pages = mission?.pages
        if (mission?.questions?.[questionIndex + 1].popupPageId) {
            pages = mission?.pages.map(p => ({ ...p, initial: (p.id === mission?.questions?.[questionIndex + 1].popupPageId) ? true : (p.initial || false) }))
        }
        setmission({ 
            ...mission,
            progress: Math.max(Number(questionIndex) + 1, progress),
        })
         if (scrollRef.current) {
            setTimeout(() => { scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 1000)
        }
        if (mission?.questions?.[questionIndex + 1].popupPageId) {
                settabIndex(mission?.pages.findIndex(p => p.id == mission?.questions?.[questionIndex + 1].popupPageId))
        }
        setquestionIndex(questionIndex + 1)
        // let result = await studentUpdateMissionById(props.token?.token, mission._id, {
        //     questions: mission?.questions,
        //     progress: Math.max(Number(questionIndex) + 1, progress),
        //     pages,
        // })
       
        // if (result.result) {
        //     await fetchMission()
        //     setquestionIndex(questionIndex + 1)
        //     if (scrollRef.current) {
        //         setTimeout(() => { scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 1000)
        //     }
        //     if (mission?.questions?.[questionIndex + 1].popupPageId) {
        //         settabIndex(mission?.pages.findIndex(p => p.id == mission?.questions?.[questionIndex + 1].popupPageId))
        //     }
        // } else {
        //     alert(JSON.stringify(result?.message))
        // }
        setisLoading(false)
    }

    const [isShowInstruction, setisShowInstruction] = useState(false)



    const [showReadySubmitPopup, setshowReadySubmitPopup] = useState(false)
    const handleSubmitTask = async () => {
        setisCompleted(true)
        setmission({
            ...mission,
            finishTime: new Date(),
            startTime,
            status: '已完成',
        })
        // setisLoading(true)
        // let result = await studentFinishMission(props.token.token, mission._id, mission.questions, progress)
        // if (result.result) {
        //     await fetchMission()
        //     setshowReadySubmitPopup(false)
        // } else {
        //     alert(JSON.stringify(result?.message))
        // }
        // setisLoading(false)
        // return
    }

    const [isShowPopup, setisShowPopup] = useState(false)
    const [selectedAvatar, setselectedAvatar] = useState(null)
    const [isShowTeacherAvatar, setisShowTeacherAvatar] = useState(false)
    const [hasSelectedAvatar, sethasSelectedAvatar] = useState(false)
    const handleSelectAvatar = async () => {
        sethasSelectedAvatar(true)
        // setisLoading(true)
        // let result = await studentSelectAvatar(props.token.token, mission._id, selectedAvatar)
        // if (result.result) {
        //     await fetchMission()
        // } else {
        //     alert(JSON.stringify(result?.message))
        // }
        // setisLoading(false)
    }

    useEffect(() => {
        if(mission?.questions?.[questionIndex]?.type==='老師導語' && mission?.questions?.[questionIndex]?.isSkip){
            handleNextQuestion()
        }
    },[mission,questionIndex])

    const [showAlertIncorrectPopup, setShowAlertIncorrectPopup] = useState(false)


    if(isCompleted){
        return (
            <ResultStudentReport mission={mission}/>
        )
    }
    if (isDoingMission && (hasConsented===null)) {
        return (
            <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black]' style={{ overflowY: "auto" }}>
                {/*buttons*/}
                <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
                    <div className='text-[#1D1D41] text-d-24 font-[400] cursor-pointer' onClick={() => { setisDoingMission(false) }}>{`<`} 返回</div>
                </div>
                {/*end of buttons*/}
                <div className='flex-[3] flex flex-col gap-[16px] min-w-[300px]'>
                    <div className='font-[700]'>閲讀任務: {mission?.name}</div>
                    <div className='font-[400]'>
                        {/* 同意書:<br /> */}
                        <div className='w-full bg-[white] p-[16px] rounded-[10px] mt-[16px]'>
                            <MDEditor.Markdown source={mission?.consent || ''} style={{ fontSize: isMobile ? 12 : 16, whiteSpace: 'pre-wrap', color: "black", backgroundColor: "white" }} />
                        </div>
                    </div>
                    <div className='flex flex-row gap-[16px]'>
                        <div onClick={handleConsent(true)} className='font-[700] cursor-pointer hover:opacity-[0.8] px-[32px] py-[10px] rounded-[7px] bg-[#8866ff] text-[white]'>
                            {'同意'}
                        </div>
                        <div onClick={handleConsent(false)} className='font-[700] cursor-pointer hover:opacity-[0.8] px-[32px] py-[10px] rounded-[7px] bg-[#aaa] text-[white]'>
                            {'不同意'}
                        </div>
                    </div>
                    <div className='w-full bg-[white] p-[16px] rounded-[10px] mt-[16px]'>
                        <MDEditor.Markdown source={mission?.consentRemarks || ''} style={{ whiteSpace: 'pre-wrap', color: "black", backgroundColor: "white" }} />
                    </div>
                </div>

            </div>
        )
    }
    
   
    if (isDoingMission && !startTime) {
        return (
            <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black]' style={{ overflowY: "auto" }}>
                {/*buttons*/}
                <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
                    <div className='text-[#1D1D41] text-d-24 font-[400] cursor-pointer' onClick={() => { setisDoingMission(false) }}>{`<`} 返回</div>
                </div>
                {/*end of buttons*/}
                <div className='flex-[3] flex flex-col gap-[16px] min-w-[300px]'>
                    <div className='font-[700]'>閲讀任務: {mission?.name}</div>
                    <div className='font-[400]'>時間: {mission.time} 分鐘<br />
                        {/* <div className='w-full bg-[white] p-[16px] rounded-[10px] mt-[16px]'>
                        <MDEditor.Markdown source={mission?.description||''} style={{ whiteSpace: 'pre-wrap',color:"black",backgroundColor:"white",}} />
                    </div> */}
                    </div>
                    <div className='flex flex-row gap-[16px]'>
                        <div onClick={handleStart} className='font-[700] cursor-pointer hover:opacity-[0.8] px-[32px] py-[16px] rounded-[7px] bg-[#8866ff] text-[white]'>
                            開始任務
                        </div>
                        <div onClick={() => { setisDoingMission(false) }} className='font-[700] cursor-pointer hover:opacity-[0.8] px-[32px] py-[16px] rounded-[7px] bg-[#aaa] text-[white]'>
                            返回
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    if (isDoingMission && !selectedAvatar && !hasSelectedAvatar) {
        return (
            <div className='relative h-full flex-1 bg-[#D6FAF1] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black] select-none' style={{ overflowY: "auto" }}>
                {/*buttons*/}
                <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
                    <div className='text-[#1D1D41] text-d-24 font-[400] cursor-pointer' onClick={() => { setisDoingMission(false) }}>{`<`} 返回</div>
                </div>
                {/*end of buttons*/}
                {isShowTeacherAvatar ?
                    <div className='w-full flex justify-center items-center flex-col gap-[32px]'>
                        <div className='w-full flex flex-col gap-[16px] max-w-[600px]'>
                            <AvatarTeacher width='100%' onNext={handleSelectAvatar} />
                        </div>
                    </div> : <div className='w-full flex justify-center items-center flex-col gap-[32px]'>
                        <div className='w-full flex flex-col gap-[16px] max-w-[600px]'>
                            <AvatarSelect width='100%' onSelectAvatar={(a) => { setselectedAvatar(a) }} selectedAvatar={selectedAvatar} />
                            <div className='w-full h-[24px]' />
                            <AvatarNextButton width={'100%'} onNext={() => {
                                if (!selectedAvatar) {
                                    alert('請選擇一個頭像')
                                    return
                                }
                                setisShowTeacherAvatar(true)
                            }} />
                        </div>
                    </div>}
            </div>
        )
    }
    if (isDoingMission)
        return (
            <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex text-[black]' style={{ overflowY: "auto", fontSize: isMobile ? 12 : 16 }}>
                {/*header*/}
                <div className='w-full flex flex-row justify-between items-center bg-[black]' style={{ gap: isMobile ? '4px' : '16px', overflow: 'auto', paddingLeft: isMobile ? 8 : 24, paddingRight: isMobile ? 8 : 24, height: isMobile ? 50 : 65 }}>
                    <Timer text={getRemainingTimeString()} percentage={(1 - ((remainingTime || 0) / ((mission.time * 60) || 1))) * 100} />
                    {/* <div className='bg-[#00E6BD] rounded-[24px] h-[48px] font-[700] text-[#001D37] px-[24px] flex flex-row items-center' style={{ boxShadow: '4px 4px 16px 0px #5C5C5C4D', border: "2px solid white" }} >
                        {getRemainingTimeString()}
                    </div> */}
                    <div className='flex-1 flex flex-row justify-start items-center' style={{ marginLeft: isMobile ? 5 : 32, gap: isMobile ? '4px' : '24px' }}>
                        {isMobile ? <div className='flex flex-row'>
                            {mission?.questions?.map((item, index) =>
                                !['選擇網頁', '選擇題', '短句作答題', '選擇題 + 短句作答題', '表格問題', '拖放式問題', '拉選題'].includes(item.type)
                                    ? <div key={item?.id || index} />
                                    : <div onClick={selectQuestion(item, index)} key={item?.id || index} className='h-[24px] w-[24px] cursor-pointer flex flex-row justify-center items-center font-[700] rounded-[8px] mr-[2px]' style={{ backgroundColor: index === questionIndex ? 'rgb(0,166,220)' : index <= progress ? '#rgb(0,166,220)' : '#aaa', color: index === questionIndex ? 'white' : 'black' }}>
                                        {mission?.questions?.filter((q, qi) => qi <= index && ['選擇網頁', '選擇題', '短句作答題', '選擇題 + 短句作答題', '表格問題', '拖放式問題', '拉選題'].includes(q.type)).length}
                                    </div>
                            )}
                        </div>
                            : <div className='flex flex-row'>
                                {mission?.questions?.map((item, index) =>
                                    !['選擇網頁', '選擇題', '短句作答題', '選擇題 + 短句作答題', '表格問題', '拖放式問題', '拉選題'].includes(item.type)
                                        ? <div key={item?.id || index} />
                                        : <div onClick={selectQuestion(item, index)} key={item?.id || index} className='h-[36px] w-[36px] cursor-pointer flex flex-row justify-center items-center font-[700] rounded-[12px] mr-[4px]' style={{ backgroundColor: index === questionIndex ? 'rgb(0,166,220)' : index <= progress ? 'rgb(0,166,220)' : '#aaa', color: index === questionIndex ? 'white' : 'black' }}>
                                            {mission?.questions?.filter((q, qi) => qi <= index && ['選擇網頁', '選擇題', '短句作答題', '選擇題 + 短句作答題', '表格問題', '拖放式問題', '拉選題'].includes(q.type)).length}
                                        </div>
                                )}
                            </div>
                        }
                    </div>
                    <div className='text-[32px] font-[700] text-[#1F4CC8]' style={{ display: isSuperSmall ? 'none' : 'flex' }}>
                        <LogoNoText width={isMobile ? '60px' : '90px'} />
                    </div>
                </div>
                {/*end of header*/}

                {/*content*/}
                <div className='flex flex-row w-full flex-1 bg-[#D9D9D9]' style={{ overflow: 'hidden' }}>
                    {/*webpages*/}
                    <div className='flex flex-col w-full bg-[white]' style={{ border: isMobile ? '2px solid black' : '2px solid black', padding: isMobile ? 4 : 10 }}>
                        {/*tabs*/}
                        <div className='flex flex-row w-full items-end justify-start bg-[white]' style={{ border: '2px solid black', paddingLeft: isMobile ? 4 : 16, paddingRight: isMobile ? 4 : 16, gap: isMobile ? 2 : 8, paddingTop: isMobile ? 2 : 6 }} >
                            {mission?.questions?.[questionIndex]?.type === '選擇網頁'
                                ? <div className='flex flex-row items-center gap-[8px] px-[12px] py-[4px] cursor-pointer hover:opacity-[.7] mb-[-2px]' style={{ backgroundColor: '#EEF2F6', borderTop: '2px solid black', borderLeft: '2px solid black', borderRight: '2px solid black', borderBottom: '2px solid #EEF2F6' }}>

                                    <div className='font-[900]' style={{ color: 'black', fontSize: isMobile ? 12 : 16 }}>Google Search</div>
                                </div>
                                : mission?.pages?.map((page, index) =>
                                    page?.initial ?
                                        <div onClick={() => { settabIndex(index) }} key={page.id || index} className='flex flex-row items-center gap-[8px] px-[12px] py-[4px] cursor-pointer hover:opacity-[.7] mb-[-2px]' style={{ backgroundColor: tabIndex === index ? '#EEF2F6' : 'white', borderTop: '2px solid black', borderLeft: '2px solid black', borderRight: '2px solid black', borderBottom: tabIndex === index ? '2px solid #EEF2F6' : '2px solid white' }}>
                                            <div className='font-[900]' style={{ color: tabIndex == index ? 'black' : 'black', fontSize: isMobile ? 12 : 16 }}>{page?.name}</div>
                                        </div>
                                        : <div key={page?.id || index} />
                                )}
                        </div>
                        <div className='w-full flex flex-row bg-[white] items-center' style={{ border: isMobile ? '2px solid black' : '2px solid black', marginTop: 4, marginBottom: 4, gap: isMobile ? 2 : 6, padding: isMobile ? 2 : 6 }}>
                            <div className='cursor-pointer'>
                                <PreviousSvg height={isMobile ? 18 : 30} width={isMobile ? 18 : 30} />
                            </div>
                            <div className='cursor-pointer'>
                                <NextSvg height={isMobile ? 18 : 30} width={isMobile ? 18 : 30} />
                            </div>
                            <div className='cursor-pointer'>
                                <ReloadSvg height={isMobile ? 18 : 30} width={isMobile ? 18 : 30} />
                            </div>
                            <div className='flex-1'>
                                <input disabled={true} className='w-full text-[black] bg-[#EEF2F6] rounded-[4px]' value={mission?.questions?.[questionIndex]?.type === '選擇網頁' ? 'https://google.com' : mission?.pages?.[tabIndex]?.url || 'xxx.yyy.com'} style={{ fontSize: isMobile ? 10 : 16, height: isMobile ? 26 : 40, paddingLeft: isMobile ? 12 : 24, paddingRight: isMobile ? 12 : 24 }} />
                            </div>
                        </div>
                        {/*end tabs*/}

                        {/*web content*/}
                        <div key={`web-content-${tabIndex}`} className='flex w-full flex-1 bg-[white]' style={{ overflowY: 'auto', border: '2px solid black' }}>
                            {(mission?.questions?.[questionIndex].isShowEmptyPage) ?
                                <div className='w-full flex flex-col justify-start items-center p-[32px]'>

                                </div>
                                : (mission?.questions?.[questionIndex]?.type === '選擇網頁') ?
                                    <div className='w-full flex flex-col justify-start items-center p-[32px]'>
                                        <div className='w-full flex flex-row items-center justify-start gap-[16px] px-[32px]'>
                                            <img className='w-[100px]' src='/google.png' alt='google logo' />
                                            <div className='flex-1 flex flex-row items-center gap-[16px] py-[8px] px-[24px] justify-between' style={{ border: '2px solid #eee', borderRadius: '99px' }}>
                                                {/* {mission?.name} */}{' '}
                                                <img className='w-[18px]' src='/gspeaker.png' alt='google logo' />
                                            </div>
                                        </div>
                                        <div className='flex flex-col pl-[48px] w-full'>
                                            {mission?.questions?.[questionIndex]?.options?.map((option, index) =>
                                                <div key={index} className='flex flex-col items-start gap-[4px] mt-[24px]'>
                                                    <div className='cursor-pointer text-[blue] hover:opacity-[0.7] underline' onClick={async () => {
                                                        let mission_ = { ...mission }
                                                        let isAnsweredBefore = mission_?.questions?.[questionIndex].options.some(o => o.isSelected)
                                                        if(!isAnsweredBefore){
                                                            mission_.questions[questionIndex].options = mission_.questions[questionIndex].options.map(option => ({ ...option, isSelected: false }))
                                                            mission_.questions[questionIndex].options[index].isSelected = true
                                                        }
                                                        setmission(mission_)
                                                        if (questionIndex === mission_?.questions?.length - 1) { setshowReadySubmitPopup(true); return }
                                                        setisLoading(true)
                                                        let pages = mission_?.pages
                                                        let isCorrect = mission_?.questions?.[questionIndex].options[index].correct
                                                        if (mission_?.questions?.[questionIndex + 1].popupPageId)
                                                            pages = mission_?.pages.map(p => ({ ...p, initial: (p.id === mission_?.questions?.[questionIndex + 1].popupPageId) ? true : (p.initial || false) }))
                                                        // let result = await studentUpdateMissionById(props.token?.token, mission_._id, { questions: mission_?.questions, progress: Math.max(Number(questionIndex) + 1, progress), pages })
                                                        setmission({ 
                                                            ...mission_,
                                                            progress: Math.max(Number(questionIndex) + 1, progress),
                                                            pages
                                                        })
                                                        let result = { result: true } //to do remove later
                                                        // if (result.result) {
                                                            // await fetchMission()
                                                            setquestionIndex(questionIndex + 1)
                                                            if(!isCorrect)setShowAlertIncorrectPopup(true)
                                                            if (scrollRef.current)
                                                                setTimeout(() => { scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 1000)
                                                            if (mission_?.questions?.[questionIndex + 1].popupPageId)
                                                                settabIndex(mission_?.pages.findIndex(p => p.id == mission_?.questions?.[questionIndex + 1].popupPageId))
                                                        // } else {
                                                        //     alert(JSON.stringify(result?.message))
                                                        // }
                                                        setisLoading(false)
                                                    }}>{option.text}</div>
                                                    <div className='text-[12px] text-[green]'>{option.url}</div>
                                                    <div className='text-[14px] text-[#aaa]'>{option.description}</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    : <div className='w-full flex flex-col h-full overflow-auto' style={mission?.pages?.[tabIndex]?.bg_url ? { backgroundImage: `url(${mission?.pages?.[tabIndex]?.bg_url || ''})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'repeat' } : {}}>
                                        <div className='w-full flex flex-col relative' style={{}}>
                                            {mission?.pages?.[tabIndex]?.contents?.map((item, index) =>
                                                <div key={index} className='w-full flex flex-col rounded-[7px] gap-[8px]' style={item?.isCustom ? (item?.customStyle || {}) : {}}>
                                                    {item?.type?.includes('文章標題') && <div className='flex flex-col w-full gap-[8px]'>
                                                        <div className={`px-[16px] font-[700]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: item.type === '文章標題(左對齊)' ? 'left' : item.type === '文章標題(居中對齊)' ? 'center' : 'right' }}>
                                                            <MDEditor.Markdown wrapperElement={{ "data-color-mode": "light" }} source={item?.text || ''} style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent", fontSize: isMobile ? 24 : 32 }} />
                                                        </div>
                                                    </div>}
                                                    {item?.type?.includes('閱讀文章內容') && <div className='flex flex-col w-full gap-[8px]'>
                                                        <div className={`px-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: item.type === '閱讀文章內容(左對齊)' ? 'left' : item.type === '閱讀文章內容(居中對齊)' ? 'center' : 'right' }}>
                                                            <MDEditor.Markdown wrapperElement={{ "data-color-mode": "light" }} source={item?.text || ''} style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent", fontSize: isMobile ? 16 : 20 }} />
                                                        </div>
                                                    </div>}
                                                    {item?.type === '圖片' &&
                                                        <div className='w-full flex flex-col'>
                                                            {item?.photo && <div className='relative w-full flex flex-row justify-center p-[16px]' style={{ backgroundColor: item?.backgroundColor || 'white' }}>
                                                                {
                                                                    item?.photo
                                                                        ? <img style={{ height: 400, width: 400, objectFit: 'contain', maxWidth: '100%' }} src={item?.photo} alt='image' />
                                                                        : <div></div>
                                                                }
                                                            </div>}
                                                        </div>
                                                    }
                                                    {item.type === '超連結' && <div className='flex flex-col w-full gap-[8px]'>
                                                        <div className={`px-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: 'left' }}>
                                                            <div cl style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent", fontSize: isMobile ? 16 : 20 }}>
                                                                <div className='inline' dangerouslySetInnerHTML={{ __html: (item.redirects?.[0] ? item?.text?.slice(0, item.redirects?.[0]?.start) : item?.text) || '' }} />
                                                                {item.redirects?.sort((a, b) => (a.start > b.start) ? 1 : (a.start < b.start) ? -1 : 0
                                                                )?.map((r, ri) =>
                                                                    <div className='inline' key={ri}>
                                                                        <div className='inline text-[blue] cursor-pointer underline'
                                                                            onClick={async () => {
                                                                                let newTabIndex = mission?.pages.findIndex(p => p.id == r.pageId)
                                                                                let mission_ = { ...mission }
                                                                                mission_.pages[newTabIndex].initial = true
                                                                                setmission(mission_)
                                                                                settabIndex(mission?.pages.findIndex(p => p.id == r.pageId))
                                                                                if (mission.questions[questionIndex]?.isRequireClick && item.clickId && item.clickId === mission.questions[questionIndex]?.isRequireClick) {
                                                                                    handleNextQuestion()
                                                                                }
                                                                            }}
                                                                            dangerouslySetInnerHTML={{ __html: item?.text.slice(r.start, r.end) }}
                                                                        />
                                                                        <div className='inline' dangerouslySetInnerHTML={{
                                                                            __html:
                                                                                item.redirects?.[ri + 1] ?
                                                                                    item?.text.slice(r.end, item.redirects?.[ri + 1].start)
                                                                                    : item?.text.slice(r.end)
                                                                        }} />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>}
                                                    {item.type === '彈出視窗' && <div className='flex flex-col gap-[8px]'>
                                                        <div className={`px-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: 'left' }}>
                                                            <div cl style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent", fontSize: isMobile ? 16 : 20 }}>
                                                                <div className='inline' dangerouslySetInnerHTML={{ __html: (item.popups?.[0] ? item?.text?.slice(0, item.popups?.[0]?.start) : item?.text) || '' }} />
                                                                {item.popups?.sort((a, b) => (a.start > b.start) ? 1 : (a.start < b.start) ? -1 : 0
                                                                )?.map((r, ri) =>
                                                                    <div className='inline' key={ri}>
                                                                        <div className='inline text-[blue] cursor-pointer' style={{ textDecoration: item.noUnderline ? 'none' : 'underline' }}
                                                                            onClick={() => {
                                                                                setisShowPopup(r.text)
                                                                                if (mission.questions[questionIndex]?.isRequireClick && item.clickId && item.clickId === mission.questions[questionIndex]?.isRequireClick) {
                                                                                    handleNextQuestion()
                                                                                }
                                                                            }}
                                                                            dangerouslySetInnerHTML={{ __html: item?.text.slice(r.start, r.end) }}
                                                                        />
                                                                        <div className='inline' dangerouslySetInnerHTML={{
                                                                            __html:
                                                                                item.popups?.[ri + 1] ?
                                                                                    item?.text.slice(r.end, item.popups?.[ri + 1].start)
                                                                                    : item?.text.slice(r.end)
                                                                        }} />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>}

                                                </div>
                                            )}
                                        </div>
                                    </div>
                            }
                        </div>
                        {/*end of web content*/}
                    </div>
                    {/*end of webpages*/}


                    {/*question*/}
                    <div className='flex flex-col h-full bg-[white] justify-start items-start text-[black]' style={{ border: isMobile ? "2px solid black" : '2px solid black', fontSize: isMobile ? 12 : 16, width: isMobile ? 500 : 600 }}>
                        {/* <div className='w-full bg-[#1F4CC8] text-[white]' style={{padding:isMobile?6:16,fontSize:isMobile?12:16}}>
                            <div className='font-[700]' style={{fontSize:isMobile?16:24}}>{mission?.name}</div>
                            <div>問題 {questionIndex + 1} / {mission?.questions.length}</div>
                        </div> */}
                        <div className='w-full bg-[rgb(176,31,28)] h-[80px]' style={{ borderBottom: '2px solid black' }}>
                            <div className='text-[white] text-[24px] font-[700] flex justify-center items-center h-full'>
                                {mission?.name}
                            </div>
                        </div>

                        <div className='flex-1 w-full flex flex-col gap-[8px]' style={{ overflowY: 'auto' }}>

                            {mission?.questions?.filter((q, qIndex) => qIndex <= progress)?.map((q, qIndex) =>
                                <div
                                    key={qIndex}
                                    className='w-full flex flex-col p-[8px] cursor-pointer'
                                    style={{ border: questionIndex === qIndex ? '8px solid rgb(211,16,39)' : '8px solid transparent', borderRadius: 4, backgroundColor: (!['老師導語', '提示語', '選擇網頁'].includes(q.type)) ? 'rgb(213,235,241)' : 'white' }}
                                    onClick={() => {
                                        if (qIndex === questionIndex) return
                                        saveAndGoToQuestion(qIndex)
                                    }}
                                >
                                    {['老師導語'].includes(q.type) && <div className='flex flex-row w-full gap-[4px]'>
                                        <div className='h-[70px] w-[70px] bg-[#aaa]' style={{}}>
                                            <img src='/teacher.jpg' style={{ width: '100%', height: '100%' }} />
                                        </div>
                                        <div className='flex flex-1 flex-col'>
                                            <div className='text-[rgb(144,24,10)] font-bold text-[18px]'>老師</div>
                                            <div className='flex-1' dangerouslySetInnerHTML={{
                                                __html: q?.dialog || ''
                                            }} />
                                            {questionIndex === qIndex && (!q.isRequireClick) && <div className='flex w-full justify-end items-center'>
                                                <div className='cursor-pointer hover:opacity-[0.8] text-[blue] font-bold text-[18px]' onClick={handleNextQuestion}>
                                                    {/* <NextSvg /> */}
                                                    下一步
                                                </div>
                                            </div>}
                                        </div>
                                    </div>}
                                    {['提示語'].includes(q.type) && <div className='flex flex-row w-full gap-[4px] items-center'>
                                        <div className='h-[30px] w-[30px]' style={{}}>
                                            <img src='/hint.png' style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                        </div>
                                        <div className='flex flex-1 flex-col'>
                                            <div className='text-[#2089dd] font-bold text-[18px]'>提示</div>
                                            <div className='flex-1' dangerouslySetInnerHTML={{
                                                __html: q?.dialog || ''
                                            }} />
                                            {questionIndex === qIndex && (!q.isRequireClick) && <div className='flex w-full justify-end items-center'>
                                                <div className='cursor-pointer hover:opacity-[0.8] text-[rgb(144,24,10)] font-bold text-[18px]' onClick={handleNextQuestion}>
                                                    <NextSvg />
                                                </div>
                                            </div>}
                                        </div>
                                    </div>}

                                    {['選擇網頁'].includes(q.type) && <div className='flex flex-row w-full gap-[4px]'>
                                        <div className='h-[70px] w-[70px] bg-[#aaa]' style={{}}>
                                            <img src='/teacher.jpg' style={{ width: '100%', height: '100%' }} />
                                        </div>
                                        <div className='flex flex-1 flex-col'>
                                            <div className='text-[rgb(144,24,10)] font-bold text-[18px]'>老師</div>
                                            <div className='flex-1' dangerouslySetInnerHTML={{
                                                __html: q?.dialog || ''
                                            }} />
                                        </div>
                                    </div>}

                                    {['選擇題', '選擇題 + 短句作答題', '拉選題'].includes(q?.type) &&
                                        <MDEditor.Markdown source={q?.question || ''} style={{ fontSize: isMobile ? 12 : 16, whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent" }} />
                                    }
                                    {['短句作答題'].includes(q?.type) && <MDEditor.Markdown source={q?.questionShortanswer || ''} style={{ whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent", fontSize: isMobile ? 12 : 16 }} />}

                                    {!['老師導語', '提示語', '選擇網頁'].includes(q.type) &&
                                        <div className='flex flex-row w-full gap-[4px]'>
                                            <div className='h-[70px] w-[70px] bg-[#aaa]' style={{}}>
                                                <img src={selectedAvatar === '1' ? '/female.jpg' : '/male.jpg'} style={{ width: '100%', height: '100%' }} />
                                            </div>
                                            <div className='flex flex-1 flex-col'>
                                                <div className='text-[rgb(144,24,10)] font-bold text-[18px]'>學生</div>
                                                <div className='flex-1' dangerouslySetInnerHTML={{
                                                    __html: q?.dialog || ''
                                                }} />
                                            </div>
                                        </div>
                                    }

                                   



                                    {['選擇題', '選擇題 + 短句作答題'].includes(q.type) &&
                                        <div className='w-full mt-[16px] flex flex-col items-start gap-[16px]'>
                                            {q?.options?.map((option, optionIndex) => (
                                                <div key={optionIndex} className='w-full flex flex-col gap-[4px]'>
                                                    <div className='flex flex-row gap-[8px] items-center'>
                                                        <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                            <button onClick={() => {
                                                                if (qIndex !== questionIndex) return
                                                                let mission_ = { ...mission }
                                                                if (mission_.questions[qIndex].multipleChoiceType !== '多項選擇題') {
                                                                    mission_.questions[qIndex].options = mission_.questions[qIndex].options.map(option => ({ ...option, isSelected: false }))
                                                                    mission_.questions[qIndex].options[optionIndex].isSelected = true
                                                                } else {
                                                                    let maxSelections = 999 //mission_.questions[qIndex].maxSelections || 2
                                                                    let currentSelections = mission_.questions[qIndex].options.filter(o => o.isSelected).length
                                                                    //if already selected, unselect it
                                                                    if (mission_.questions[qIndex].options[optionIndex].isSelected) {
                                                                        mission_.questions[qIndex].options[optionIndex].isSelected = false
                                                                    } else {
                                                                        //if not selected, check if max selections reached
                                                                        if (currentSelections < maxSelections) {
                                                                            mission_.questions[qIndex].options[optionIndex].isSelected = true
                                                                        }
                                                                    }
                                                                    // mission_.questions[qIndex].options[optionIndex].isSelected = !mission_?.questions?.[qIndex].options[optionIndex].isSelected
                                                                }
                                                                setmission(mission_)
                                                            }}
                                                                className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${option.isSelected ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                            ></button>
                                                        </div>
                                                        {option.text}
                                                    </div>
                                                    <div style={{ borderBottom: '4px dotted #2089dd' }}></div>
                                                </div>
                                            ))}
                                            {(questionIndex === qIndex) && (q.type !== '選擇題 + 短句作答題') && <div className='w-full flex flex-row justify-end items-center'>
                                                <div className='cursor-pointer hover:opacity-[0.8] text-[white] font-bold text-[18px] bg-[rgb(245,140,0)] px-[12px] py-[4px] rounded-[10px]' onClick={handleNextQuestion}>
                                                    儲存
                                                </div>
                                            </div>}
                                            {(questionIndex !== qIndex && progress !== qIndex) && (q.type !== '選擇題 + 短句作答題') && <div className='w-full flex flex-row justify-end items-center'>
                                                <div className='cursor-pointer hover:opacity-[0.8] text-[white] font-bold text-[18px] bg-[rgb(0,152,65)] px-[12px] py-[4px] rounded-[10px]'>
                                                    已儲存
                                                </div>
                                            </div>}
                                        </div>
                                    }
                                    {['拉選題'].includes(q.type) &&
                                        <div className='w-full mt-[16px] flex flex-col items-start gap-[16px]'>
                                            <DropDownMenu options={q?.options.map(o => o.text)} value={q.options?.find(o => o.isSelected)?.text || '-- 請選擇 --'} style={{ backgroundColor: 'white' }} select={(item, index) => {
                                                if (qIndex !== questionIndex) return
                                                let mission_ = { ...mission }
                                                mission_.questions[qIndex].options = mission_.questions[qIndex].options.map(option => ({ ...option, isSelected: false }))
                                                mission_.questions[qIndex].options[index].isSelected = true
                                                setmission(mission_)

                                            }} />

                                            {(questionIndex === qIndex) && <div className='w-full flex flex-row justify-end items-center mt-[100px]'>
                                                <div className='cursor-pointer hover:opacity-[0.8] text-[white] font-bold text-[18px] bg-[rgb(245,140,0)] px-[12px] py-[4px] rounded-[10px]' onClick={handleNextQuestion}>
                                                    儲存
                                                </div>
                                            </div>}
                                            {(questionIndex !== qIndex && progress !== qIndex) && <div className='w-full flex flex-row justify-end items-center'>
                                                <div className='cursor-pointer hover:opacity-[0.8] text-[white] font-bold text-[18px] bg-[rgb(0,152,65)] px-[12px] py-[4px] rounded-[10px]'>
                                                    已儲存
                                                </div>
                                            </div>}
                                        </div>
                                    }

                                    {['短句作答題', '選擇題 + 短句作答題'].includes(q?.type) && (
                                        <div className='w-fill mt-[16px] flex flex-col p-[2px]'>
                                            {['選擇題 + 短句作答題'].includes(q?.type) && <MDEditor.Markdown source={q?.questionShortanswer || ''} style={{ whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent", fontSize: isMobile ? 12 : 16 }} />}
                                            <textarea
                                                className='w-full flex flex-col bg-[#F8F8F8] gap-[8px] rounded-[2px] mt-[16px]' style={{ border: '1px solid #00000080', boxShadow: '0px 0px 2px 2px rgb(217,229,193)', padding: isMobile ? 4 : 8 }}
                                                value={q?.answer || ''}
                                                maxLength={120}
                                                placeholder='請輸入答案'
                                                onChange={(e) => {
                                                    if (qIndex !== questionIndex) return
                                                    let mission_ = { ...mission }
                                                    mission_.questions[qIndex].answer = e.target.value
                                                    setmission(mission_)
                                                }}
                                                onPaste={(e) => {
                                                    //disable paste
                                                    e.preventDefault()
                                                    return false
                                                }}
                                            />
                                            {/* <div>{q?.answer?.length || 0}/120 字</div> */}
                                            {q.hasTwoAnswers && <textarea
                                                className='w-full flex flex-col bg-[#F8F8F8] gap-[8px] rounded-[2px] mt-[16px]' style={{ border: '1px solid #00000080', boxShadow: '0px 0px 2px 2px rgb(217,229,193)', padding: isMobile ? 4 : 8 }}
                                                value={q?.answer2 || ''}
                                                maxLength={120}
                                                placeholder='請輸入答案'
                                                onPaste={(e) => {
                                                    //disable paste
                                                    e.preventDefault()
                                                    return false
                                                }}
                                                onChange={(e) => {
                                                    if (qIndex !== questionIndex) return
                                                    let mission_ = { ...mission }
                                                    mission_.questions[qIndex].answer2 = e.target.value
                                                    setmission(mission_)
                                                }}
                                            />}
                                            {/* {q.hasTwoAnswers && <div>{q?.answer2?.length || 0}/120 字</div>} */}
                                            {(questionIndex === qIndex) && <div className='w-full flex flex-row justify-end items-center mt-[16px]'>
                                                <div className='cursor-pointer hover:opacity-[0.8] text-[white] font-bold text-[18px] bg-[rgb(245,140,0)] px-[12px] py-[4px] rounded-[10px]' onClick={handleNextQuestion}>
                                                    儲存
                                                </div>
                                            </div>}
                                            {(questionIndex !== qIndex && progress !== qIndex) && <div className='w-full flex flex-row justify-end items-center mt-[16px]'>
                                                <div className='cursor-pointer hover:opacity-[0.8] text-[white] font-bold text-[18px] bg-[rgb(0,152,65)] px-[12px] py-[4px] rounded-[10px]'>
                                                    已儲存
                                                </div>
                                            </div>}
                                        </div>
                                    )}
                                </div>
                            )}

                            <div ref={scrollRef} />


                        </div>
                        {/* <div className='flex w-full flex flex-col p-[16px]'>
                            <div onClick={handleNextQuestion} className='font-[700] cursor-pointer hover:opacity-[0.8] px-[32px] py-[16px] rounded-[7px] bg-[#1F4CC8] text-[white] text-center'>
                                保存並繼續
                            </div>
                        </div> */}
                    </div>
                    {/*end of question*/}
                </div>
                {/*end of content*/}

                {showReadySubmitPopup && <div className='fixed top-0 left-0 w-full h-full bg-[#00000090] flex flex-col justify-center items-center'>
                    <div className='flex flex-col gap-[8px] bg-[white] rounded-[16px] max-w-[548px] w-full text-[black]' style={{ overflow: 'hidden' }}>
                        <div className='font-[700] bg-[#1F4CC8] text-[36px] w-full text-center py-[16px] text-white'>小提示:</div>
                        <div className='text-[30px] w-full text-center mt-[24px]'>如確定完成任務</div>
                        <div className='text-[30px] w-full text-center'>將不能再次修改答案</div>
                        <div className='w-full flex flex-row gap-[32px] my-[24px] items-center justify-center'>
                            <div onClick={handleSubmitTask} className='font-[700] text-[28px] cursor-pointer hover:text-[white] hover:bg-[#1F4CC8] px-[36px] py-[4px] rounded-[99px] text-[#1F4CC8]' style={{ border: '3px solid #1F4CC8' }}>
                                確定
                            </div>
                            <div onClick={() => { setshowReadySubmitPopup(false) }} className='font-[700] text-[28px] cursor-pointer hover:text-[white] hover:bg-[#1F4CC8] px-[36px] py-[4px] rounded-[99px] text-[#1F4CC8]' style={{ border: '3px solid #1F4CC8' }}>
                                返回
                            </div>
                        </div>
                    </div>
                </div>}
                {showAlertIncorrectPopup&& <div className='fixed top-0 left-0 w-full h-full bg-[#00000090] flex flex-col justify-center items-center'>
                    <div className='flex flex-col gap-[8px] bg-[white] rounded-[16px] max-w-[548px] w-full text-[black] items-center justify-center flex' style={{ overflow: 'hidden' }}>
                        <div className='h-[70px] w-[70px] bg-[#aaa] mt-[24px]' style={{}}>
                            <img src='/teacher.jpg' style={{ width: '100%', height: '100%' }} />
                        </div>
                        <div className='text-[30px] w-full text-center'>現在為你跳轉到正確的網站</div>
                        <div className='w-full flex flex-row gap-[32px] my-[24px] items-center justify-center'>
                            <div onClick={() => { setShowAlertIncorrectPopup(false) }} className='font-[700] text-[28px] cursor-pointer hover:text-[white] hover:bg-[#1F4CC8] px-[36px] py-[4px] rounded-[99px] text-[#1F4CC8]' style={{ border: '3px solid #1F4CC8' }}>
                                確定
                            </div>
                        </div>
                    </div>
                </div>}
                {isShowInstruction && <Instructions close={() => { setisShowInstruction(false) }} />}
                {isShowPopup && <PopupWindow text={isShowPopup} onClose={() => { setisShowPopup(false) }} />}
            </div>
        )
    return (
        <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black]' style={{ overflowY: "auto" }}>
            {/*buttons*/}
            <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
                <div className='text-[#1D1D41] text-d-24 font-[400] cursor-pointer' onClick={() => { navigate('/public/missions') }}>{`<`} 返回</div>
            </div>
            {/*end of buttons*/}

            <div className='w-full flex flex-row gap-[48px] mt-[16px] flex-wrap'>
                <div className='flex-[3] flex flex-col gap-[16px] min-w-[300px]'>
                    <div className='font-[700]'>閲讀任務: {mission?.name}</div>
                    <div className='font-[400]'>簡介:<br />
                        <div className='w-full bg-[white] p-[16px] rounded-[10px] mt-[16px]'>
                            <MDEditor.Markdown source={mission?.description || ''} style={{ fontSize: isMobile ? 12 : 16, whiteSpace: 'pre-wrap', color: "black", backgroundColor: "white" }} />
                        </div>
                    </div>
                    <div className='flex flex-row gap-[16px]'>
                        <div onClick={handleStartMission} className='font-[700] cursor-pointer hover:opacity-[0.8] p-[16px] rounded-[7px] bg-[#8866ff] text-[white]'>
                            開始任務
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LoadingPage />}
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
